import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";

const adminToken = secureStorage.getItem("adminToken");
const API_URL = "/admin/local/neighbourhood";

const headers = {
  Authorization: `Bearer ${adminToken}`,
  "Content-Type": "application/json",
};

const initialFormData = {
  id: null,
  neighbourhoodName: "",
  countryId: "",
  divisionId: "",
  cityId: "",
  status: 1,
};

export const viewNeighbourhood = async (setNeighbourhoodData, setLoading) => {
  if (setLoading) setLoading(true);

  try {
    const res = await axiosInstance.get(API_URL, { headers });
    setNeighbourhoodData(res.data.data || []);
    return true;
  } catch (error) {
    console.error("View neighbourhood error:", error);
    toast.error(
      error.response?.data?.message || "Failed to fetch neighbourhoods",
    );
    return false;
  } finally {
    if (setLoading) setLoading(false);
  }
};

export const addNeighbourhood = async (
  FormData,
  setFormData,
  setNeighbourhoodData,
  setLoading,
) => {
  try {
    const res = await axiosInstance.post(API_URL, FormData, {
      headers,
    });

    if (res.data.message === "Neighbourhood added successfully") {
      toast.success("Neighbourhood added successfully");
      setFormData({ ...initialFormData });
      await viewNeighbourhood(setNeighbourhoodData, setLoading);
      return true;
    }

    toast.error(res.data.message || "Failed to add neighbourhood");
    return false;
  } catch (error) {
    console.error("Add neighbourhood error:", error);
    toast.error(error.response?.data?.message || "Failed to add neighbourhood");
    return false;
  }
};

export const updateNeighbourhood = async (
  FormData,
  setFormData,
  setNeighbourhoodData,
  setLoading,
) => {
  try {
    const res = await axiosInstance.put(API_URL, FormData, {
      headers,
    });

    if (res.data.message === "Neighbourhood updated successfully") {
      toast.success("Neighbourhood updated successfully");
      setFormData({ ...initialFormData });
      await viewNeighbourhood(setNeighbourhoodData, setLoading);
      return true;
    }

    toast.error(res.data.message || "Failed to update neighbourhood");
    return false;
  } catch (error) {
    console.error("Update neighbourhood error:", error);
    toast.error(
      error.response?.data?.message || "Failed to update neighbourhood",
    );
    return false;
  }
};

export const deleteNeighbourhood = async (
  id,
  setNeighbourhoodData,
  setLoading,
) => {
  try {
    const res = await axiosInstance.delete(API_URL, {
      headers,
      data: { id },
    });

    if (res.data.message === "Neighbourhood deleted successfully") {
      toast.success("Neighbourhood deleted successfully");
      await viewNeighbourhood(setNeighbourhoodData, setLoading);
      return true;
    }

    toast.error(res.data.message || "Failed to delete neighbourhood");
    return false;
  } catch (error) {
    console.error("Delete neighbourhood error:", error);
    toast.error(
      error.response?.data?.message || "Failed to delete neighbourhood",
    );
    return false;
  }
};
